import React from 'react';
import ScimManagerList from 'features/scim-management/components/ScimManagerList';

export default function UserManagementScimManagersTab(): JSX.Element {
  return (
    <div className="w-full mt-[3.2rem] mx-auto py-6 px-dashboard-side bg-dashboard-background">
      <ScimManagerList />
    </div>
  );
}
